import type { SVGProps } from 'react';
import ZepIcon from '../ZepIcon';
export const BoltFillColorVioletIcon = ZepIcon((props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
      <path fill="url(#Bolt-fill-color-violet_svg__a)" fillRule="evenodd" d="M13.31 2.05A1 1 0 0 1 14 3v6h5a1 1 0 0 1 .809 1.588l-8 11A1 1 0 0 1 10 21v-6H5a1 1 0 0 1-.809-1.588l8-11a1 1 0 0 1 1.118-.363" clipRule="evenodd" />
      <defs>
        <linearGradient id="Bolt-fill-color-violet_svg__a" x1={4} x2={20} y1={12} y2={12} gradientUnits="userSpaceOnUse">
          <stop stopColor="#8478FF" />
          <stop offset={1} stopColor="#3DA9FF" />
        </linearGradient>
      </defs>
    </svg>);